
import { useState } from 'react';

export default function GoogleReviews() {
  const [showAll, setShowAll] = useState(false);

  const reviews = [
    {
      id: 1,
      author: 'María G.',
      rating: 5,
      date: 'Hace 2 semanas',
      text: 'Estamos encantados con la escuela. Las profesoras tienen una vocación increíble y se nota el cariño con el que tratan a los niños. Mi hijo va feliz cada día.',
      avatar: 'MG'
    },
    {
      id: 2,
      author: 'Carlos R.',
      rating: 5,
      date: 'Hace 1 mes',
      text: 'El proyecto bilingüe es excelente. La maestra de inglés está integrada en el día a día y los niños aprenden de forma natural. Las instalaciones son muy buenas.',
      avatar: 'CR'
    },
    {
      id: 3,
      author: 'Laura M.',
      rating: 5,
      date: 'Hace 2 meses',
      text: 'La flexibilidad horaria y el servicio de webcam nos dan mucha tranquilidad. Podemos ver a nuestra hija en cualquier momento y el equipo siempre está disponible.',
      avatar: 'LM'
    },
    {
      id: 4,
      author: 'Javier P.',
      rating: 5,
      date: 'Hace 3 meses',
      text: 'El acompañamiento emocional que ofrecen es maravilloso. Respetan los ritmos de cada niño y el servicio psicopedagógico es un gran apoyo para las familias.',
      avatar: 'JP'
    },
    {
      id: 5,
      author: 'Ana S.',
      rating: 4,
      date: 'Hace 4 meses',
      text: 'Muy contentos con la adaptación de nuestro hijo. El patio exterior es genial y la comida casera elaborada en el centro es de calidad. Recomendable.',
      avatar: 'AS'
    },
    {
      id: 6,
      author: 'Roberto F.',
      rating: 5,
      date: 'Hace 5 meses',
      text: 'La profesionalidad del equipo es excepcional. Las tutoras y el personal de apoyo están muy bien coordinados. Los "Días sin Cole" son un servicio muy útil.',
      avatar: 'RF'
    }
  ];

  const displayedReviews = showAll ? reviews : reviews.slice(0, 3);

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Opiniones de Familias
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Lee lo que dicen las familias que confían en nosotros
          </p>
        </div>

        {/* Google Rating Summary */}
        <div className="bg-gradient-to-br from-teal-50 to-orange-50 rounded-2xl p-8 mb-12 text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            <img 
              src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
              alt="Google" 
              className="h-8"
            />
            <span className="text-gray-600 text-lg font-medium">Reseñas</span>
          </div>
          <div className="flex items-center justify-center gap-3 mb-2">
            <span className="text-6xl font-bold text-gray-900">4.8</span>
            <div>
              <div className="flex gap-1 mb-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i 
                    key={star} 
                    className={`${star <= 5 ? 'ri-star-fill' : 'ri-star-line'} text-2xl text-yellow-400`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-gray-600">Basado en 66 reseñas</p>
            </div>
          </div>
          <a 
            href="https://www.google.com/maps/place/Escuela+Infantil+Duendecillos+Let's+Play/@40.4445,-3.6089,17z" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 mt-4 text-teal-600 hover:text-teal-700 font-medium transition-colors cursor-pointer"
          >
            <span>Ver todas las reseñas en Google</span>
            <i className="ri-external-link-line"></i>
          </a>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {displayedReviews.map((review) => (
            <div 
              key={review.id}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-orange-500 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0">
                  {review.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-gray-900 mb-1">{review.author}</h4>
                  <div className="flex items-center gap-2 mb-1">
                    <div className="flex gap-0.5">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i 
                          key={star} 
                          className={`${star <= review.rating ? 'ri-star-fill' : 'ri-star-line'} text-sm text-yellow-400`}
                        ></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-xs text-gray-500">{review.date}</p>
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed">{review.text}</p>
            </div>
          ))}
        </div>

        {/* Show More Button */}
        <div className="text-center">
          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 px-8 py-3 bg-teal-600 text-white rounded-full hover:bg-teal-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            <span>{showAll ? 'Mostrar menos' : 'Ver más reseñas'}</span>
            <i className={`ri-arrow-${showAll ? 'up' : 'down'}-s-line`}></i>
          </button>
        </div>

        {/* Leave Review CTA */}
        <div className="mt-12 text-center bg-gradient-to-r from-teal-50 to-orange-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            ¿Eres parte de nuestra familia?
          </h3>
          <p className="text-gray-600 mb-6">
            Comparte tu experiencia y ayuda a otras familias a conocernos
          </p>
          <a
            href="https://www.google.com/maps/place/Escuela+Infantil+Duendecillos+Let's+Play/@40.4445,-3.6089,17z/data=!4m8!3m7!1s0x0:0x0!8m2!3d40.4445!4d-3.6089!9m1!1b1!16s%2Fg%2F11c1z8qz8z?hl=es"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-3 bg-white border-2 border-teal-600 text-teal-600 rounded-full hover:bg-teal-600 hover:text-white transition-all font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-star-line"></i>
            <span>Dejar una reseña en Google</span>
          </a>
        </div>
      </div>
    </section>
  );
}
